"use client";

import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";
import { useLocale, useTranslations } from "use-intl";
import RelatedProperties from "../layout/Related";
import CommuteCalculator from "./CommuteCalculator";
import LifeMapCommute from "./LifeMapCommute";
import PropertyMap from "./PropertyMap";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export default function PropertyFeatures({
  features = [],
  id = "",
  googleLink,
}: {
  features: string[];
  id: string;
  googleLink?: any;
}) {
  const t = useTranslations("Properties");
  const locale = useLocale();

  console.log(googleLink);

  return (
    <div className="py-10 px-4 sm:px-6 lg:px-8">
      {/* Title */}
      <div className="flex items-center gap-3 xs:gap-5 mb-8">
        <h2 className="text-lg sm:text-2xl font-extrabold text-main">
          {t("features")}
        </h2>
        <span className="w-full h-0.5 bg-gray-400 flex-1 rounded"></span>
      </div>

      {/* Features Grid */}
      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {features?.map((feature: any, index) => (
          <motion.div
            key={index}
            className="flex items-center gap-4 p-4 bg-white rounded-2xl shadow-md hover:shadow-xl cursor-pointer transition-transform duration-300"
          >
            {/* Animated Icon */}
            <motion.div
              className="w-12 h-12 rounded-full bg-main/10 flex items-center justify-center"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <CheckCheck className="text-main w-6 h-6" />
            </motion.div>

            {/* Feature Text */}
            <p className="text-dark font-medium text-sm sm:text-base">
              {locale === "ar" ? feature?.feature_ar : feature?.feature_en}
            </p>
          </motion.div>
        ))}
      </motion.div>

      <div className="mt-14">
        <div className="flex items-center gap-3 xs:gap-5">
          <h2 className="text-lg sm:text-2xl font-extrabold text-main">
            {t("location")}
          </h2>
          <span className="w-full h-0.5 bg-gray-400 flex-1 rounded"></span>
        </div>

        <PropertyMap
          latitude={googleLink?.latitude || 24.7136}
          longitude={googleLink?.longitude || 46.6753}
          title={locale === "ar" ? "الموقع على الخريطة" : "Location on Map"}
        />

        <CommuteCalculator
          latitude={googleLink?.latitude}
          longitude={googleLink?.longitude}
        />

        <LifeMapCommute
          latitude={googleLink?.latitude}
          longitude={googleLink?.longitude}
        />
      </div>

      <RelatedProperties id={id} tab="all" />
    </div>
  );
}
